import type transform from '../to/syllabuses';

export default (syllabuses: ReturnType<typeof transform>) => {
  syllabuses = syllabuses.filter(({ id }) => id != undefined);

  if (syllabuses.length != Array.from(new Set(syllabuses.map(({ id }) => id))).length)
    throw new Error('(Core::From::V2::Syllabuses) Syllabuses array have two or more syllabuses with the same ID');

  return syllabuses.map(syllabus => {
    if (!syllabus.id)
      throw new Error('(Core::From::V2::Syllabuses) Syllabus id is undefined');

    return { ...syllabus };
  }, []) satisfies ReturnType<typeof transform>;
};